import React from 'react';
import { WebChatSyncUI } from '../../shell/WebChatSync';

class Loader extends React.Component {
    render() {
        return <WebChatSyncUI isSyncing={true} isSyncComplete={false} progress={0} />;
    }
}

export default Loader;
